// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3Q_w7","insightsList":"newBusinessInsightsMenu_insightsList__3NZM9","active":"newBusinessInsightsMenu_active__casUZ"};